import { fileProvider } from './fileProvider';
import { xlsxProvider } from './xlsxProvider';
import { persistentAtom } from '@nanostores/persistent';

export const $selectedProvider = persistentAtom<keyof typeof providers>(
  'selectedProvider',
  'File',
);

export const providers = {
  File: fileProvider,
  Excel: xlsxProvider,
};

export const providerNames = Object.keys(
  providers,
) as (keyof typeof providers)[];

export function getSelectedProvider() {
  return providers[$selectedProvider.get()];
}

export function setSelectedProvider(provider: keyof typeof providers) {
  $selectedProvider.set(provider);
}
